<style lang="less">
	@import "../assets/css/product_details.less";
</style>
<template>
	<div class="gz_idc product">
		<div class="w1100 box">
			<article>
				<h4 class="title"><span>01</span>公证IDC</h4>
				<p>公证人员在办理公证业务中，应用”人像比对“、”实人核验“、”手机号核验“、”银行卡核验“等多种验证手段核验当事人真实身份信息，降低公证办理中的业务风险！</p>
				<p>公证人员使用公证IDC客户端软件采集当事人身份相关信息，通过包括人脸识别在内的多种手段核验当事人真实身份（还可以核验该身份在其他领域是否黑名单），将身份验证云平台的核验结果实时呈现出来；也可以在公证IDC查询管理后台系统查看、打印、下载；和业务系统对接后，还可以实时将核验结果发送到公证业务系统；</p>
				<h4><span>02</span>客户端</h4>
				<ul class='imgList clearfix client'>
					<li><img src="../assets/img/gz_03.jpg" />
						<p>PC客户端</p>
					</li>
					<li><img src="../assets/img/gz_05.jpg" />
						<p>移动客户端</p>
					</li>
				</ul>
				<h4><span>03</span>管理后台</h4>
				<ul class='imgList clearfix backstage'>
					<li><img src="../assets/img/gz_09.jpg" />
						<p>管理后台</p>
					</li>
					<li><img src="../assets/img/gz_11.jpg" />
						<p>核验结果下载</p>
					</li>
				</ul>
				<h4><span>04</span>媒体报道</h4>
				<iframe src='http://player.youku.com/embed/XMjgzNTY0MjA4OA==' frameborder=0 allowfullscreen></iframe>
				<div class="download">
					<h4><span>05</span>软件下载</h4>
					<ul class="clearfix">
						<li>
							<img src="../assets/img/gz_android.jpg" />
							<p>安卓下载</p>
						</li>
						<li>
							<img src="../assets/img/gz_ios.jpg" />
							<p>IOS下载</p>
						</li>
						<li>
							<img src="../assets/img/gz_wx.jpg" />
							<p>小程序二维码</p>
						</li>
						<li><a href="http://soft-updata.oss-cn-beijing.aliyuncs.com/pc_notarization/%E5%85%AC%E8%AF%81IDC.exe"  target="_blank">
							<img src="../assets/img/windows.png" />
							<p>PC下载</p>
						</a></li>
					</ul>

				</div>
				<div class="softWork">
					<h4><span>06</span>产品软著</h4>
					<img src="../assets/img/gz_14.jpg" />
				</div>
				<h4><span>07</span>部分案例</h4>
				<p>北京市长安公证处、上海市东方公证处、天津市北方公证处、重庆市公证处、新疆维吾尔自治区法诺公证处、西安市汉唐公证处、成都市蜀都公证处、昆明市真元公证处、昆明市国正公证处、广州市南方公证处、福州市闽江公证处、南昌赣江公证处、武汉市楚信公证处、石家庄燕赵公证处、广州市公证处、哈尔滨市公证处、乌鲁木齐市公证处、武汉江天公证处、兰州市公证处、南昌市洪城公证处、北京市东方公证处、北京市海诚公证处、上海市徐汇公证处、上海市浦东公证处、重庆市沙坪坝公证处、重庆市江北公证处、石家庄平安公证处、淄博鲁中公证处、太原市城南公证处、西安市莲湖公证处、成都市中大公证处、昆明市中衡公证处、曲靖珠江源公证处、广州市海珠公证处、珠海市珠海公证处、柳州市公证处、六安市皋翔公证处、贵阳市立诚公证处、遵义市中心公证处、长沙市长沙公证处、长沙市麓山公证处、长沙市星城公证处、新乡市豫新公证处、南阳市智圣公证处、本溪市山城公证处、长春市征信公证处、赤峰市公证处</p>
			</article>
		</div>
	</div>
</template>

<script>
	export default {
		name: "gz_idc",
		data() {
			return {

			};
		},
		created() {

		},
		methods:{

		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/gz_idc.vue